
    import '/opt/buildhome/repo/components/welcome/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["welcome-demo-basic","welcome-demo-variant","welcome-demo-background","welcome-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/welcome/index.en-US.md?type=demo')
};